import { render, staticRenderFns } from "./wxMenu.vue?vue&type=template&id=616114bf&scoped=true"
import script from "./wxMenu.vue?vue&type=script&lang=js"
export * from "./wxMenu.vue?vue&type=script&lang=js"
import style0 from "./wxMenu.vue?vue&type=style&index=0&id=616114bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616114bf",
  null
  
)

export default component.exports